import { LAYOUT_LIST, TEXT } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Statement5: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(
              {
                ...item,
                title: '',
                subtitle: '',
                body: ''
              } as ItemOfType<'Card'>,
              {
                width: 'auto',
                height: 'auto',
                padding: '0px',
                extraItems: [
                  {
                    id: `title_${item.id}`,
                    type: TEXT,
                    values: {
                      value: item.title,
                      variant: 'heading2'
                    },
                    items: []
                  }
                ]
              }
            )
          ]
        };
      default:
        return null;
    }
  });
};
